import React, {Component} from 'react'
import {Col, CardHeader, CardBody, Button, Table, ButtonGroup, Card} from 'reactstrap'
import ReactPaginate from 'react-paginate'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import {WeldersListFetchQuery, destroyCertificateMutation, StandardsDimensionsWeldersQuery} from './mutations'
import {graphql, compose, withApollo} from 'react-apollo'
import ConfirmModal from '../Alerts/ConfirmModal'
import {UnmountClosed} from 'react-collapse'
import CertificateForm from './CertificateForm'
import CertificateConfirmationModal from './CertificateConfirmationModal'
import ExportWeldersModal from './export_welders/ExportWeldersModal'
import WeldersFilter from './WeldersFilter'
import BlockWithLoader from '../Support/BlockWithLoader'
import {prepareFiltersFromUrl, getDimensionsValueForUrl} from './helpers/filtersHelper'
import CertificateRow from './helpers/CertificateRow'
import {getUserPermissions} from '../../utils/userPermissions'
import SwitchRadioBtn from '../Support/SwitchRadioBtn'

class WeldersList extends Component {

  constructor(props) {
    super(props)
    const parsed_search = queryString.parse(this.props.location.search)
    this.state = {
      welders_list: [],
      welder_certificates: [],
      page_count: 0,
      form_is_opened: false,
      data_to_edit: {},
      page: Number(parsed_search.page) || 1,
      certificate_id_remove: null,
      form_welder_id: null,
      certificate_confirmation_id: null,
      filter_form: false,
      filters: prepareFiltersFromUrl(props.location.search),
      show_certificates: localStorage.getItem('CertificatesView') !== 'show_approvals',
      show_approvals: localStorage.getItem('CertificatesView') !== 'show_certificates',
      dimensionsDictionary: [],
      standardsDictionary: [],
      exportWeldersModalOpened: false,
      merge_by_cert_no: localStorage.getItem('CertificatesMergeByNo') === 'true'
    }

    this.closeConfirmModal = this.closeConfirmModal.bind(this)
    this.runRemoveWelder = this.runRemoveWelder.bind(this)
    this.handleFormToggle = this.handleFormToggle.bind(this)
    this.clearEditData = this.clearEditData.bind(this)

    this.handleFilterFormToggle = this.handleFilterFormToggle.bind(this)
    this.runFilterWelders = this.runFilterWelders.bind(this)
    this.updateFiltersData = this.updateFiltersData.bind(this)
  }

  static propTypes = {
    location: PropTypes.object.isRequired,
    destroyCertificateMutation: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired
  }

  componentWillMount() {
    this.fetchStandardsDimensionsData()
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data.loading === false && nextProps.data.loading === false && nextProps.history.action === 'PUSH') {
      this.props.data.refetch()
    }

    if (nextProps.data.loading === false && nextProps.data.welders) {
      let welders = nextProps.data.welders.list.slice(0) //clone
      this.setState({
        welder_certificates: welders,
        page_count: nextProps.data.welders.metadata.total_pages,
        page: Number(queryString.parse(nextProps.location.search).page) || 1,
        filters: prepareFiltersFromUrl(nextProps.location.search)
      })
    }
  }

  fetchStandardsDimensionsData() {
    this.props.client.query({
      query: StandardsDimensionsWeldersQuery,
      fetchPolicy: 'network-only',
      variables: {filters: {permission_key: 'core.people.welder', active: 'true'}}
    }).then(({data}) => {
      this.setState({
        standardsDictionary: data.welder_certificate_standardizations,
        dimensionsDictionary: data.dimensions,
        welders_list: data.people.list
      })
    })
  }

  runRemoveWelder() {
    this.removeWelder(this.state.certificate_id_remove)
  }

  closeConfirmModal() {
    this.setState({certificate_id_remove: null})
  }

  removeWelder(id) {
    this.props.destroyCertificateMutation({
      variables: {id: id}
    }).then(() => {
      let newWelderCertificates = []
      this.state.welder_certificates.forEach(welder => {
        let newWelder = {
          ...welder, certificates: welder.certificates.filter(item => item.id !== id)
        }
        newWelder.certificates.length > 0 && newWelderCertificates.push(newWelder)
      })

      this.setState({welder_certificates: newWelderCertificates, certificate_id_remove: null})
    })
  }

  handlePageClick = (data) => {
    if (this.state.page !== data.selected + 1) {
      this.handleFilterInUrl(data.selected + 1)
    }
  }

  runFilterWelders() {
    this.handleFilterInUrl(1)
  }

  handleFilterInUrl(page) {
    let newFilter = {...this.state.filters}
    if (this.state.filters.dimensions) {
      newFilter.dimensions = getDimensionsValueForUrl(this.state.filters.dimensions)
    }

    const path = this.props.history.location.pathname
    this.props.history.push(`${path}?${`merge_by_cert_no=${this.state.merge_by_cert_no}&`}${`page=${page}&`}${queryString.stringify(newFilter)}`)
  }

  updateFiltersData(new_filters) {
    this.setState({filters: {...this.state.filters, ...new_filters}})
  }

  handleFormToggle() {
    this.setState({form_is_opened: !this.state.form_is_opened})
  }

  clearEditData() {
    this.setState({data_to_edit: {}, form_welder_id: null})
  }

  handleFilterFormToggle() {
    this.setState({filter_form: !this.state.filter_form})
  }

  renderListRow(welder, certificate) {
    let certificatesRows = []
    const welderPath = `/people/${welder.id}`
    const rowSpan = (this.state.show_approvals && this.state.show_certificates) ? 2 : 1
    certificatesRows.push(
      <tr key={`first_row_${welder.id}`}>
        <td key={`td1_${welder.id}`} rowSpan={rowSpan}>
          <a href={welderPath} onClick={e => e.stopPropagation()} target='_blank'><b>{`${welder.first_name} ${welder.last_name}`}</b></a>
        </td>
        <td key={`td2_${welder.id}`} rowSpan={rowSpan}>
          <a href={welderPath} onClick={e => e.stopPropagation()} target='_blank'><b>{welder.uuid}</b></a>
        </td>
        {this.state.show_certificates &&
        <CertificateRow key={`td3_${welder.id}`}
          changeParentStateFunction={(args) => this.setState(args)}
          form_is_opened={this.state.form_is_opened}
          welder_id={Number(welder.id)}
          dimensionsDictionary={this.state.dimensionsDictionary}
          certificate={certificate}
          merge_by_cert_no={this.state.merge_by_cert_no}/>}
        {this.state.show_approvals && !this.state.show_certificates &&
        <CertificateRow key={`td3_${welder.id}`}
          changeParentStateFunction={(args) => this.setState(args)}
          form_is_opened={this.state.form_is_opened}
          welder_id={Number(welder.id)}
          dimensionsDictionary={this.state.dimensionsDictionary}
          certificate={certificate.approval}
          isApproval={true}/>}
      </tr>
    )

    this.state.show_certificates && this.state.show_approvals && certificate.approval &&
    certificatesRows.push(
      <tr key={`approval_${certificate.approval.id}`}>
        <CertificateRow changeParentStateFunction={(args) => this.setState(args)}
          form_is_opened={this.state.form_is_opened}
          welder_id={Number(welder.id)}
          dimensionsDictionary={this.state.dimensionsDictionary}
          certificate={certificate.approval}
          isApproval={true}/>
      </tr>
    )

    return certificatesRows
  }

  renderList() {
    return (
      <React.Fragment>
        {this.state.welder_certificates.map(welder => {
          let certificateCount = welder.certificates.length
          return welder.certificates.map((certificate, idx) =>
            <tbody key={certificate.id} style={(certificateCount === idx + 1) ? {borderBottom: 'double'} : {}}
              onClick={() => this.props.history.push(`/welders/${certificate.id}?merge_by_cert_no=${this.state.merge_by_cert_no}`)}>
              {this.renderListRow(welder, certificate)}
            </tbody>
          )
        }
        )}
      </React.Fragment>
    )
  }

  render() {
    if (this.props.data.error) return <div>An unexpected error occurred</div>

    return (
      <BlockWithLoader loading={this.props.data.loading} renderChildren={true}>
        {this.state.exportWeldersModalOpened &&
        <ExportWeldersModal
          toggleFunction={() => this.setState({exportWeldersModalOpened: false})}
          show_certificates={this.state.show_certificates}
          show_approvals={this.state.show_approvals}
          merge_by_cert_no={this.state.merge_by_cert_no}
          filters={this.state.filters}
        />}
        {!!this.state.certificate_confirmation_id &&
        <CertificateConfirmationModal
          isOpened={true}
          onCancel={() => this.setState({certificate_confirmation_id: null})}
          afterSubmit={() => this.setState({certificate_confirmation_id: null})}
          certificate_id={Number(this.state.certificate_confirmation_id)}
        />}
        <UnmountClosed isOpened={this.state.form_is_opened}>
          <CertificateForm
            welderList={this.state.welders_list}
            standardsDictionary={this.state.standardsDictionary}
            dimensionsDictionary={this.state.dimensionsDictionary}
            formToggleFunction={this.handleFormToggle}
            editData={this.state.data_to_edit}
            clearFunction={this.clearEditData}
            welder_id={this.state.form_welder_id}
          />
        </UnmountClosed>
        <ConfirmModal
          isOpened={!!this.state.certificate_id_remove}
          onCancel={this.closeConfirmModal}
          onConfirm={this.runRemoveWelder}
          headerText='Remove Certificate'
          bodyText='Are you sure you want to delete this Certificate?'
          confirmBtnText='Remove'
        />
        <Card>
          <CardHeader>
            <b className="float-left">Welders &nbsp;</b>
            <SwitchRadioBtn label='Show certificates' checked={this.state.show_certificates}
              onChangeFunc={() => {
                this.setState({show_certificates: !this.state.show_certificates, show_approvals: true})
              }}/>
            <SwitchRadioBtn label='Show range of qualifications' checked={this.state.show_approvals}
              onChangeFunc={() => {
                this.setState({show_approvals: !this.state.show_approvals, show_certificates: true})
              }}/>
            {!this.state.form_is_opened &&
            <SwitchRadioBtn label='Group certificates by No' checked={this.state.merge_by_cert_no}
              onChangeFunc={() => {
                this.setState({merge_by_cert_no: !this.state.merge_by_cert_no}, ()=> this.handleFilterInUrl(this.state.page))
              }}
            />}
            <ButtonGroup className="float-right" style={{marginTop: '5px'}}>
              {!this.state.merge_by_cert_no && !this.state.form_is_opened && getUserPermissions('wl_welders.certificates.create') &&
              <Button color="primary" id="add-new-certificate-btn"
                onClick={() => {
                  this.setState({form_is_opened: true})
                }}>
                <i className="fa fa-plus"/> Add new certificate
              </Button>}
              {getUserPermissions('wl_welders.export_certificates_list.export_certificates_list') && <Button id="export-welders-btn" color="primary" title="Export"
                onClick={(e) => {
                  e.stopPropagation()
                  this.setState({exportWeldersModalOpened: true})
                }}>
                <i className="fa fa-print"/> Export
              </Button>}
              <Button id="open-filter-btn"
                onClick={() => {
                  this.setState({filter_form: !this.state.filter_form})
                }}
              >
                <i className="fa fa-filter"/> Filter
              </Button>
            </ButtonGroup>
          </CardHeader>
          <UnmountClosed isOpened={this.state.standardsDictionary.length > 0 && this.state.filter_form}>
            <WeldersFilter
              standardsDictionary={this.state.standardsDictionary}
              formToggleFunction={this.handleFilterFormToggle}
              submitFunction={this.runFilterWelders}
              updateFiltersFunction={this.updateFiltersData}
              filtersData={this.state.filters}
              clearFiltersDataFunction={() => this.setState({filters: {active: true}}, () => this.runFilterWelders())}
            />
          </UnmountClosed>
          <CardBody>
            <Table size="sm" bordered responsive className="table-project table-tbody-hover">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">NO</th>
                  <th scope="col">Certificate No</th>
                  <th scope="col" colSpan="11" style={{textAlign: 'center'}}>Test designation</th>
                  <th scope="col">Expiration
                  <hr style={{marginTop: '0px', marginBottom: '0px'}}/>
                  Confirmation (days left)
                  </th>
                  <th scope="col">Publisher</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              {this.renderList()}
            </Table>
          </CardBody>

          {this.state.page_count > 1 &&
          <Col className="text-center">
            <ReactPaginate
              forcePage={this.state.page - 1}
              previousLabel={'Prev'}
              nextLabel={'Next'}
              breakLabel={<a href="">...</a>}
              breakClassName={'break-me'}
              pageCount={this.state.page_count}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              containerClassName={'pagination justify-content-center'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
          </Col>}
        </Card>
      </BlockWithLoader>
    )
  }
}

const WeldersListWithMutations = compose(
  graphql(WeldersListFetchQuery, {
    options: (props) => {
      const parsed_search = queryString.parse(props.location.search)
      return ({
        fetchPolicy: 'network-only',
        variables: {
          page: Number(queryString.parse(props.location.search).page) || 1,
          filters: prepareFiltersFromUrl(props.location.search, true),
          merge_by_cert_no: parsed_search.merge_by_cert_no ?
            parsed_search.merge_by_cert_no === 'true' : localStorage.getItem('CertificatesMergeByNo') === 'true'
        }
      })
    }
  }),
  graphql(destroyCertificateMutation, {name: 'destroyCertificateMutation'})
)(WeldersList)

export default withApollo(WeldersListWithMutations)



// WEBPACK FOOTER //
// ./src/components/Welders/WeldersList.js